var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIconOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "2 2 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5837 4.5837C3.88982 5.27759 3.5 6.2187 3.5 7.2V16.8C3.5 17.7813 3.88982 18.7224 4.5837 19.4163L4.93726 19.0627L4.58371 19.4163C5.27759 20.1102 6.2187 20.5 7.2 20.5H16.8C17.7813 20.5 18.7224 20.1102 19.4163 19.4163C20.1102 18.7224 20.5 17.7813 20.5 16.8V7.2C20.5 6.2187 20.1102 5.27759 19.4163 4.58371L19.0627 4.93726L19.4163 4.5837C18.7224 3.88982 17.7813 3.5 16.8 3.5H7.2C6.2187 3.5 5.27759 3.88982 4.5837 4.5837Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0009,
    cy: 12.0009,
    r: 4.05556,
    stroke: "white",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8898,
    cy: 7.11241,
    r: 0.944444,
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIconOutline);
export default __webpack_public_path__ + "static/media/InstagramIconOutline.110f3d8943795bda5f3fad61bbe88abd.svg";
export { ForwardRef as ReactComponent };